import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  EditButton,
  DeleteButton,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from 'react-admin';
import PromoFilters from './PromoFilters';

const PromoList = props => (
  <List {...props} filters={<PromoFilters />} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="amount" />
      <ReferenceArrayField label="Plans" reference="plans" source="plan_ids">
        <SingleFieldList linkType="show">
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <DateField source="start_at" showTime />
      <DateField source="end_at" showTime />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default PromoList;



// WEBPACK FOOTER //
// ./src/resources/promos/PromoList.jsx